let config = null;

export const getDefaultFancyboxConfig = () => {
    if (!config) {
        config = {
            lang: ICUBE_CONFIG.lang,
            i18n: {}
        };

        config.i18n[config.lang] = __('__fancybox');
        Object.freeze(config);
    }

    return config;
}